import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-intent-arrow-down",
  "use": "icon-intent-arrow-down-usage",
  "viewBox": "0 0 13 7",
  "content": "<symbol viewBox=\"0 0 13 7\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-intent-arrow-down\">\n<path id=\"icon-intent-arrow-down_Vector\" d=\"M11.6484 1L6.64844 6L1.64844 1\" stroke-width=\"1.4\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol